import React from "react";
// Images Import
import brand1 from "../../Images/amazon.jpg";
import brand2 from "../../Images/walmart.png";
import brand3 from "../../Images/eBay.png";
import brand4 from "../../Images/etsy.png";
import brand5 from "../../Images/shopify.png";
import brand6 from "../../Images/woocommerce.png";
import brand7 from "../../Images/bigcommerce1.png";
import brand8 from "../../Images/Wayfair.png";
import brand9 from "../../Images/wish.png";
import brand10 from "../../Images/Overstock.png";
import brand11 from "../../Images/Target.png";
import brand12 from "../../Images/Macys.png";
import brand13 from "../../Images/ManoMano.png";
import brand14 from "../../Images/Fruugo.png";
import brand15 from "../../Images/Best_Buy_Logo.jpg";
import brand16 from "../../Images/Houzz-Logo.png";
import brand17 from "../../Images/Kroger-Logo.png";
import brand18 from "../../Images/home-depot-logo.webp";
import brand19 from "../../Images/Channeladvisor-Logo-Vector.png";
import brand20 from "../../Images/ecomdash.webp";
import brand21 from "../../Images/sellbrite.png";
import brand22 from "../../Images/linkworks.png";
import brand23 from "../../Images/solidCommerce.webp";
import brand24 from "../../Images/Helium 10.webp";
import brand25 from "../../Images/Sellozo.png";
import brand26 from "../../Images/email-marketing.jpg";
import brand27 from "../../Images/SOCIAL-MEDIA-MARKETING.png";
import brand28 from "../../Images/lead-generation.png";
import brand29 from "../../Images/Google-Ad.png";
import brand30 from "../../Images/seo.jpg";
import brand31 from "../../Images/magento.webp";
import brand32 from "../../Images/WordPress.png";

function ModalServices() {
  return (
    <>
      {/* Services Modal Data Managment Start */}

      <div
        className="modal modal-xl"
        id="modalDM"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                <i className="fa-solid fa-envelope"></i> info@fleekcommerce.com
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h5 style={{ fontWeight: "300", marginBottom: "0px" }}>
                  Amazon and Other Ecommerce
                </h5>
                <h3>Data Management</h3>

                <p>
                  Unlock the full potential of your ecommerce business with our
                  expert data management services. We offer a comprehensive
                  range of services to help you manage your accounts, inventory,
                  orders, listings, and marketplaces on platforms such as
                  Amazon, eBay, Walmart, Shopify, Magento, and more.
                </p>

                <p>
                  We have extensive experience in managing multi-channel
                  software like Linnworks, channelAdvisor, Sellbrite, and
                  others. We also offer virtual assistant services to help you
                  with social media handling, promotional offer management,
                  competitor analysis, product sourcing, research, and more. Let
                  us help you optimize your ecommerce business and achieve your
                  goals!
                </p>
              </div>

              <div className="mt-5">
                <div
                  className="cs_brands cs_style_1"
                  style={{ justifyContent: "flex-start" }}
                >
                  <div className="cs_brand">
                    <img
                      src={brand1}
                      alt="brand_image"
                      style={{ width: "100px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand2}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand3}
                      alt="brand_image"
                      style={{ width: "100px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand4}
                      alt="brand_image"
                      style={{ width: "80px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand5}
                      alt="brand_image"
                      style={{ width: "110px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand6}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand7}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand8}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand9}
                      alt="brand_image"
                      style={{ width: "90px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand10}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand11}
                      alt="brand_image"
                      style={{ width: "100px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand12}
                      alt="brand_image"
                      style={{ width: "110px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand13}
                      alt="brand_image"
                      style={{ width: "150px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand14}
                      alt="brand_image"
                      style={{ width: "90px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand15}
                      alt="brand_image"
                      style={{ width: "60px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand16}
                      alt="brand_image"
                      style={{ width: "120px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand17}
                      alt="brand_image"
                      style={{ width: "90px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand18}
                      alt="brand_image"
                      style={{ width: "60px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Services Modal Multichannel Softwares Start */}

      <div
        className="modal modal-xl"
        id="modalMS"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                <i className="fa-solid fa-envelope"></i> info@fleekcommerce.com
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h5 style={{ fontWeight: "300", marginBottom: "0px" }}>
                  Amazon and Other Ecommerce
                </h5>
                <h3>Multichannel Softwares</h3>

                <p>
                  Multichannel eCommerce services enable businesses to manage
                  their online sales across multiple platforms (such as Amazon,
                  eBay, Walmart, Etsy, etc.) from a single interface. These
                  services help streamline operations, automate inventory
                  management, optimize listings, and centralize orders,
                  providing a seamless experience across different sales
                  channels.
                </p>

                <p>
                  These platforms are essential for businesses looking to expand
                  their presence on multiple eCommerce channels and manage their
                  sales, orders, and inventory more effectively. Each of these
                  services provides a centralized approach to selling, allowing
                  businesses to maximize their reach and sales while minimizing
                  errors and manual work.
                </p>
              </div>

              <div className="mt-5">
                <div
                  className="cs_brands cs_style_1"
                  style={{ justifyContent: "flex-start" }}
                >
                  <div className="cs_brand">
                    <img
                      src={brand19}
                      alt="brand_image"
                      style={{ width: "180px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand20}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand21}
                      alt="brand_image"
                      style={{ width: "120px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand22}
                      alt="brand_image"
                      style={{ width: "160px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand23}
                      alt="brand_image"
                      style={{ width: "110px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Services Modal Sponsored Ads Start */}

      <div
        className="modal modal-xl"
        id="modalSA"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                <i className="fa-solid fa-envelope"></i> info@fleekcommerce.com
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h5 style={{ fontWeight: "300", marginBottom: "0px" }}>
                  Amazon and Other Ecommerce
                </h5>
                <h3>Sponsored Ads</h3>

                <p>
                  Maximize your ecommerce sales with our comprehensive PPC and
                  Sponsored Ad services. Our expert in-house team creates and
                  executes targeted advertising campaigns on popular
                  marketplaces like Amazon, eBay, Walmart, and more. We've
                  helped thousands of businesses achieve their goals by
                  increasing visibility, driving traffic, and boosting sales.
                </p>

                <p>
                  With our data-driven insights and strategic approach, we
                  optimize your campaigns to maximize ROI. Whether you need
                  Amazon PPC, AdWords optimization and management, Bing Ads
                  management, App marketing, or PPC audits, we've got you
                  covered. Let us take your ecommerce business to the next level
                  and experience the difference that our PPC marketing service
                  can make. Partner with us today and watch your business grow.
                </p>
              </div>

              <div className="mt-5">
                <div
                  className="cs_brands cs_style_1"
                  style={{ justifyContent: "flex-start" }}
                >
                  <div className="cs_brand">
                    <img
                      src={brand1}
                      alt="brand_image"
                      style={{ width: "100px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand2}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand3}
                      alt="brand_image"
                      style={{ width: "100px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand4}
                      alt="brand_image"
                      style={{ width: "80px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand8}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand10}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand11}
                      alt="brand_image"
                      style={{ width: "100px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand12}
                      alt="brand_image"
                      style={{ width: "110px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand18}
                      alt="brand_image"
                      style={{ width: "60px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand19}
                      alt="brand_image"
                      style={{ width: "180px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand24}
                      alt="brand_image"
                      style={{ width: "150px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand25}
                      alt="brand_image"
                      style={{ width: "110px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Services Modal Digital Marketing Start */}

      <div
        className="modal modal-xl"
        id="modalDMar"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                <i className="fa-solid fa-envelope"></i> info@fleekcommerce.com
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h5 style={{ fontWeight: "300", marginBottom: "0px" }}>
                  Amazon and Other Ecommerce
                </h5>
                <h3>Digital Marketing</h3>

                <p>
                  At Fleek Commerce, we believe that digital marketing is not
                  just about driving traffic to your website, but also about
                  converting those visitors into loyal customers. That's why we
                  offer a comprehensive suite of digital marketing services to
                  help you grow your online business. Our services include SEO
                  and SEM, blog creation, Google Shopping, Google Analytics,
                  Email Marketing, Social Media Marketing, and more.
                </p>

                <p>
                  From creating effective ad campaigns to optimizing your
                  website for search engines, we have the expertise and
                  experience to help you achieve your marketing goals. So if
                  you're ready to take your online business to the next level,
                  get in touch with us today. Let us help you develop a
                  customized digital marketing strategy that's tailored to your
                  unique business needs. Contact us now and let's start growing
                  your online business together!
                </p>
              </div>

              <div className="mt-5">
                <div
                  className="cs_brands cs_style_1"
                  style={{ justifyContent: "flex-start" }}
                >
                  <div className="cs_brand">
                    <img
                      src={brand26}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand27}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>
                  <div className="cs_brand">
                    <img
                      src={brand28}
                      alt="brand_image"
                      style={{ width: "110px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand29}
                      alt="brand_image"
                      style={{ width: "180px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand30}
                      alt="brand_image"
                      style={{ width: "110px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Services Modal Website Development Start */}

      <div
        className="modal modal-xl"
        id="modalWD"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                <i className="fa-solid fa-envelope"></i> info@fleekcommerce.com
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h5 style={{ fontWeight: "300", marginBottom: "0px" }}>
                  Shopify and Other Ecommerce
                </h5>
                <h3>Website Development</h3>

                <p>
                  We strive for perfection in every aspect of our web design to
                  ensure that it aligns with your business strategy. Our team
                  analyzes, integrates, and processes your vision to produce the
                  best results. Because we know that in the dynamic world of
                  digital commerce, attracting, engaging, and retaining
                  customers is critical.
                </p>

                <p>
                  At Fleek Commerce, we make it simple for you to get started
                  with powerful ecommerce solutions using Shopify, Magento,
                  WooCommerce, and many more. Our skilled team of ecommerce web
                  store developers has completed projects for everyone from
                  small to large businesses. Our affordable pricing has
                  attracted lots of small and medium businesses around the
                  world.
                </p>
              </div>

              <div className="mt-5">
                <div
                  className="cs_brands cs_style_1"
                  style={{ justifyContent: "flex-start" }}
                >
                  <div className="cs_brand">
                    <img
                      src={brand5}
                      alt="brand_image"
                      style={{ width: "110px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand6}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand31}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>

                  <div className="cs_brand">
                    <img
                      src={brand32}
                      alt="brand_image"
                      style={{ width: "130px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Services Modal Creative Graphics Start */}

      <div
        className="modal modal-xl"
        id="modalCG"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                <i className="fa-solid fa-envelope"></i> info@fleekcommerce.com
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h5 style={{ fontWeight: "300", marginBottom: "0px" }}>
                  Amazon and Other Ecommerce
                </h5>
                <h3>Creative Graphics</h3>

                <p>
                  Fleek Commerce understands the power of visual communication,
                  where a single image can convey a thousand words. Our creative
                  graphics designing services are tailored to captivate your
                  audience and leave a lasting impression. From your Business
                  Logo Creation and SMM Banners (Social Media Banners) to Brand
                  Store Design and A+ Content (Amazon EBC), our expert team
                  ensures your brand stands out from the competition.
                </p>

                <p>
                  We specialize in Infographics, Feature Image / Listing Image
                  Creation, Background Removal, Clipping Path Services, CGI
                  (Computer Generated Images) Lifestyle Image Creation, Image
                  Retouching, Image Manipulation, Video Editing, UI/UX
                  Designing, Newsletter Design, Brochure Design and more. With
                  our comprehensive range of services, we can bring your vision
                  to life and help your business thrive. Contact us today to
                  unlock the potential of captivating design
                </p>
              </div>

              <div className="mt-5">
                <div
                  className="cs_brands cs_style_1"
                  style={{ justifyContent: "flex-start" }}
                >
                  <div className="cs_brand">
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> A+
                      Content design
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Photo
                      editing
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Brands
                      store design
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Feature
                      Images
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Video
                      editing
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Logo
                      Design
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i>{" "}
                      Newsletter design
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Social
                      media banner design
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i>{" "}
                      Packaging gift card design
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> ID
                      card/Visiting Card Design/Flyer
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Adobe
                      Photoshop
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Adobe
                      Illustrator
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Adobe
                      InDesign
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Adobe
                      After effect
                    </p>

                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Adobe
                      Premier pro
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Services Modal Customer Support Start */}

      <div
        className="modal modal-xl"
        id="modalCS"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                <i className="fa-solid fa-envelope"></i> info@fleekcommerce.com
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h5 style={{ fontWeight: "300", marginBottom: "0px" }}>
                  Amazon and Other Ecommerce
                </h5>
                <h3>Customer Support</h3>

                <p>
                  Your ecommerce success hinges on outstanding customer service,
                  and that's where Fleek Commerce truly shines. We recognize the
                  critical role customer satisfaction plays in maintaining
                  account health and fostering business growth. Our skilled
                  Customer Service Team is well-versed in handling Customer
                  Messages and FAQs, Managing Feedback and Review Requests,
                  facilitating seamless Order, Return, Refund, and Replacement
                  Processes, liaising with Warehouses, Manufacturers, and
                  Freight Forwarders, coordinating with Shipping Carriers, and
                  providing Comprehensive Shipment Tracking Services.
                </p>

                <p>
                  Additionally, we offer Marketplace and Social Media Support,
                  Effective Inbound Sales Management, Streamlined Inventory
                  Replenishment, In-Depth Order And Performance Reporting. Count
                  on us to deliver customer service excellence that sets your
                  business apart.
                </p>
              </div>

              <div className="mt-5">
                <div
                  className="cs_brands cs_style_1"
                  style={{ justifyContent: "flex-start" }}
                >
                  <div className="cs_brand">
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i>{" "}
                      Responding Customer Inquiries
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Resolve
                      Customer Complaints & Issues
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Order
                      Processing & Management
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Return,
                      Refund & Replacement Processing
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Shipping
                      Carrier Management
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i>{" "}
                      Warehouse, Manufacturer & Freight Forwarder Management
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Shipment
                      Creation & Tracking
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i>{" "}
                      Contacting Marketplace Support
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Feedback
                      & Review Management
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Social
                      Media Support
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Inbound
                      Sales Management
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i> Invoice
                      & Shipping Label Management
                    </p>
                    <p style={{ fontSize: "20px" }}>
                      <i className="fa-solid fa-square-check me-2"></i>{" "}
                      Reporting: Order Report & Performance Report
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ModalServices;
